import React from 'react';
import type { Video } from '../types';

interface VideoCardProps {
    video: Video;
    onSelect: () => void;
}

const PlayIcon: React.FC<{ className?: string }> = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="5 3 19 12 5 21 5 3"></polygon>
    </svg>
);

const VideoCard: React.FC<VideoCardProps> = ({ video, onSelect }) => {
    const thumbnailUrl = `https://i.ytimg.com/vi/${video.youtubeVideoId}/hqdefault.jpg`;

    return (
        <div className="group">
            <button
                onClick={onSelect}
                className="block w-full relative overflow-hidden aspect-video mb-4"
                aria-label={`Play video: ${video.title}`}
            >
                <img
                    src={thumbnailUrl}
                    alt={video.title}
                    className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-500 ease-in-out"
                />
                <div className="absolute inset-0 bg-black bg-opacity-40 group-hover:bg-opacity-20 transition-opacity duration-300"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center opacity-100 md:opacity-0 md:group-hover:opacity-100 transform scale-100 md:group-hover:scale-110 transition-all duration-300 backdrop-blur-sm">
                        <PlayIcon className="w-8 h-8 text-white" />
                    </div>
                </div>
            </button>
            <h3 className="text-xl font-semibold mt-2 group-hover:text-gray-600 transition-colors font-heading">{video.title}</h3>
            <p className="text-gray-600 mt-2 text-sm leading-relaxed font-body">{video.description}</p>
        </div>
    );
};

export default VideoCard;
